import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQueryWithAuthLogout } from "./index"

export const dashboardAPI = createApi({
    reducerPath: "dashboardAPI",
    baseQuery: baseQueryWithAuthLogout,
    tagTypes: ["Dashboard"],
    endpoints: (builder) => ({
        getDashboardData: builder.query({
            query: () => `/dashboard/dashboard-summary`,
            providesTags: ["Dashboard"],
        }),


    }),
});

export const {
    useGetDashboardDataQuery,
} = dashboardAPI;
